function DB(DB_CONFIG) {
  var self = {}
  self.db = null

  self.db_open = function() {
    return new Promise((resolve, reject) => {
      try {
        if (window.sqlitePlugin) {
          self.db = window.sqlitePlugin.openDatabase({
            name: DB_CONFIG.name,
            location: 'default'
          }, function() {
            resolve(true)
          })
        } else {
          let dbSize = 5 * 1024 * 1024 // 5MB
          self.db = openDatabase(DB_CONFIG.name, '1.0', DB_CONFIG.name, dbSize)
          resolve(true)
        }
      } catch (e) {
        reject(e)
      }
    })
  }

  self.init = async function() {
    await self.db_open()
    let queries = []
    DB_CONFIG.tables.forEach(table => {
      let columns = []
      table.columns.forEach(column => {
        columns.push(column.name + ' ' + column.type)
      })
      let query = 'CREATE TABLE IF NOT EXISTS ' + table.name + ' (' + columns.join(',') + ')'      
      queries.push(self.query(query))
    })
    return Promise.all(queries)
  }

  self.migrateExistingTable = async function(dbConfig) {
    // migrate exixting table if new column is added
    console.log('Start migration...')
    let queries = []
    await dbConfig.tables.forEach(async (table) => {
      let columns = []
      let query = 'SELECT * FROM ' + table.name   
      let responce = await self.query(query)
      if(responce.rows.length > 0) {
        let exitingColumnArray = Object.keys(responce.rows.item(0))
        let existTableColumns = []
        table.columns.forEach(column => {
          if(exitingColumnArray.indexOf(column.name) == -1) {
            columns.push({name: column.name, type: column.type})
          } else {
            existTableColumns.push({name: column.name, type: column.type})
          }
        })
        
        if(columns.length > 0) {
          console.log('Start migration for ', table.name)
          let newTableColumns = table.columns
          let newTableColumnsWithType = []
          newTableColumns.forEach(column => {
            newTableColumnsWithType.push(column.name + ' ' + column.type)
          })
          let existTableColumnsNames = []
          existTableColumns.forEach(column => {
            existTableColumnsNames.push(column.name)
          })

          let createTempTable = 'CREATE TEMPORARY TABLE ' + table.name + '_temp (' + newTableColumnsWithType.join(',') + '); '
          let insertTempTable =  'INSERT INTO ' + table.name + '_temp (' + existTableColumnsNames.join(',') + ')  SELECT ' + existTableColumnsNames.join(',') + ' FROM ' + table.name + '; '
          let dropOldTable =  'DROP TABLE ' + table.name + '; '
          let createNewTable =  'CREATE TABLE IF NOT EXISTS ' + table.name + ' (' + newTableColumnsWithType.join(',') + '); '
          let insertNewTempTable =  'INSERT INTO ' + table.name + ' (' + existTableColumnsNames.join(',') + ') SELECT ' + existTableColumnsNames.join(',') + ' FROM ' + table.name + '_temp; '
          let dropTempTable =  'DROP TABLE ' + table.name + '_temp;'

          await self.query(createTempTable)
          await self.query(insertTempTable)
          await self.query(dropOldTable)
          await self.query(createNewTable)
          await self.query(insertNewTempTable)
          await self.query(dropTempTable)
          console.log('End migration for ', table.name)
        }
      }
    })
    console.log('End migration')
    return Promise.all(queries)
  }

  self.delete = (tablename, keyColumn, IdValue) => {
    /* if (isNaN(IdValue)) {
      IdValue = `'${IdValue}'`
    } */
    return new Promise((resolve, reject) => {
      self.db.transaction(function(transaction) {
        let query = `DELETE FROM ${tablename} WHERE ${keyColumn} = ${IdValue}`
        transaction.executeSql(query, [], function(transaction, result) {
          resolve(result)
        }, function(transaction, error) {
          console.log('error', error)
          reject(error)
        })
      })
    })
  }

  self.deleteByStringId = (tablename, keyColumn, IdValue) => {
    if (isNaN(IdValue)) {
      IdValue = `'${IdValue}'`
    }
    return new Promise((resolve, reject) => {
      self.db.transaction(function(transaction) {
        let query = `DELETE FROM ${tablename} WHERE ${keyColumn} = ${IdValue}`
        transaction.executeSql(query, [], function(transaction, result) {
          resolve(result)
        }, function(transaction, error) {
          console.log('error', error)
          reject(error)
        })
      })
    })
  }

  self.insertRow = (tablename, bindings, keyColumn, IdValue) => {
    let table = DB_CONFIG.tables.find(x => x.name === tablename)
    let columns = []
    let valueFeild = []
    let values = []

    table.columns.forEach(column => {
      columns.push(column.name)
      values.push(bindings[column.name])
      valueFeild.push('?')
    })

    return new Promise((resolve, reject) => {
      self.db.transaction(function(transaction) {
        let query = `INSERT INTO ${tablename} (${columns.join(',')}) values(${valueFeild.join(',')})`
        transaction.executeSql(query, values, function(transaction, result) {
          resolve(result)
        }, function(transaction, error) {
          reject(error)
        })
      })
    })
  }

  self.updateRow = (tablename, bindings, keyColumn, IdValue) => {
    let table = DB_CONFIG.tables.find(x => x.name === tablename)
    let columns = []
    let values = []

    table.columns.forEach(column => {
      columns.push(column.name + ' = ?')
      values.push(bindings[column.name])
    })

    return new Promise((resolve, reject) => {
      self.db.transaction(function(transaction) {
        let query = `UPDATE ${tablename} SET ${columns.join(',')} where ${keyColumn} = ${IdValue}`
        transaction.executeSql(query, values, function(transaction, result) {
          resolve(result)
        }, function(transaction, error) {
          reject(error)
        })
      })
    })
  }

  self.mergeHelper = async(tablename, bindings, keyColumn) => {
    let IdValue
    if (isNaN(bindings[keyColumn])) {
      IdValue = `'${bindings[keyColumn]}'`
    } else {
      IdValue = bindings[keyColumn]
    }
    let result
    if (bindings.RowDeleted) {
      result = await self.delete(tablename, keyColumn, IdValue)
      return result
    } else {
      let execQuery = `SELECT * FROM ${tablename} WHERE ${keyColumn} = ${IdValue}`
      let responce = await self.query(execQuery)
      if (responce.rows.length === 0) {
        result = await self.insertRow(tablename, bindings, keyColumn, IdValue)
        return result
      } else {
        result = await self.updateRow(tablename, bindings, keyColumn, IdValue)
        return result
      }
    }
  }

  self.merge = function(tablename, bindings, keyColumn) {
    let result = Array.isArray(bindings)
    if (result) {
      bindings.forEach(binding => {
        return self.mergeHelper(tablename, binding, keyColumn)
      })
    } else {
      return self.mergeHelper(tablename, bindings, keyColumn)
    }
  }

  self.update = function(tablename, bindings) {
    let table = DB_CONFIG.tables.find(x => x.name === tablename)
    let columns = []
    let values = []
    let IdValue
    table.columns.forEach(column => {
      columns.push(column.name + ' = ?')
      values.push(bindings[column.name])
      if (column.name === 'Id') {
        IdValue = bindings[column.name]
      }
    })
    return new Promise((resolve, reject) => {
      self.db.transaction(function(transaction) {
        let query = `UPDATE ${tablename} SET ${columns.join(',')} where Id = ${IdValue}`
        transaction.executeSql(query, values, function(transaction, result) {
          resolve(result)
        }, function(transaction, error) {
          reject(error)
        })
      })
    })
  }

  self.runquery = async function(execQuery) {
    let result = await self.runSelectQuery(execQuery)
    return self.fetchAll(result)
  }

  self.runSelectQuery = function(execQuery) {
    return new Promise((resolve, reject) => {
      self.query(execQuery).then(function(result) {
        resolve(result)
      }, function(transaction, error) {
        reject(error)
      })
    })
  }

  self.select = function(tablename) {
    let table = DB_CONFIG.tables.find(x => x.name === tablename)
    let columns = []
    table.columns.forEach(column => {
      columns.push(column.name)
    })
    let execQuery = `SELECT ${columns.join(',')} FROM ` + table.name
    return new Promise((resolve, reject) => {
      self.query(execQuery).then(function(result) {
        resolve(result)
      }, function(transaction, error) {
        reject(error)
      })
    })
  }

  self.fetchRows = async function(tablename) {
    try {
      let result = await self.select(tablename)
      return self.fetchAll(result)
    } catch (e) {
      console.log('error', e)
    }
  }

  self.contitionalSelect = async function(tablename, columnname, key) {
    let result = await self.projection(tablename, columnname, key)
    return self.fetchAll(result)
  }

  self.projection = function(tablename, columnname, key) {
    if (isNaN(key)) {
      key = `'${key}'`
    }

    let table = DB_CONFIG.tables.find(x => x.name === tablename)
    let columns = []
    table.columns.forEach(column => {
      columns.push(column.name)
    })
    let execQuery = `SELECT ${columns.join(',')} FROM ${table.name} where ${columnname} = ${key}`
    return new Promise((resolve, reject) => {
      self.query(execQuery).then(function(result) {
        resolve(result)
      }, function(transaction, error) {
        reject(error)
      })
    })
  }

  self.selectColumns = function(tablename, columns) {
    let execQuery = `SELECT ${columns} FROM ` + tablename
    return self.query(execQuery).then(function(result) {
      return result
    })
  }

  self.insert = function(tablename, bindings) {
    let table = DB_CONFIG.tables.find(x => x.name === tablename)
    let columns = []
    let valueFeild = []
    let values = []
    table.columns.forEach(column => {
      columns.push(column.name)
      values.push(bindings[column.name])
      valueFeild.push('?')
    })
    return new Promise((resolve, reject) => {
      self.db.transaction(function(transaction) {
        let query = `INSERT INTO ${tablename} (${columns.join(',')}) values(${valueFeild.join(',')})`
        transaction.executeSql(query, values, function(transaction, result) {
          resolve(result)
        }, function(transaction, error) {
          reject(error)
        })
      })
    })
  }

  self.bulkinsert = function(tablename, bindings) {
    bindings.forEach(binding => {
      self.insert(tablename, binding)
    })
  }

  self.drop_all = function() {
    DB_CONFIG.tables.forEach(table => {
      var query = 'DROP TABLE ' + table.name
      self.query(query)
    })
  }

  self.query = function(query, bindings) {
    bindings = typeof bindings !== 'undefined' ? bindings : []
    return new Promise((resolve, reject) => {
      self.db.transaction(function(transaction) {
        transaction.executeSql(query, bindings, function(transaction, result) {
          resolve(result)
        }, function(transaction, error) {
          reject(error)
        })
      })
    })
  }

  self.fetchAll = function(result) {
    try {
      var output = []
      for (var i = 0; i < result.rows.length; i++) {
        output.push(result.rows.item(i))
      }
      return output
    } catch (e) {
      console.log('fetch all error ', e)
    }
  }

  self.fetch = function(result) {
    try {
      return result.rows.item(0)
    } catch (e) {
      console.log('fetch error', e)
    }
  }

  self.latestUpdate = function(table) {
    return self.query('SELECT MAX(updated) FROM ' + table).then(function(result) {
      return self.fetch(result)
    })
  }

  self.updateModulesContentPagesPostsLike = async(tablename, keyColumn, payload, IdValue) => {
    if (isNaN(IdValue)) {
      IdValue = `'${IdValue}'`
    }
    let columns = []
    columns.push('IsLiked = ?')
    columns.push('PostLikes = ?')
    let execQuery = `SELECT * FROM ${tablename} WHERE ${keyColumn} = ${IdValue}`
    let responce = await self.query(execQuery)
    if (responce.rows.length !== 0) {
      let values = []
      let localIsLiked = responce.rows.item(0).IsLiked
      let localPostLikes = responce.rows.item(0).PostLikes
      values.push(payload.Liked)
      if ((localIsLiked === true || localIsLiked === 'true') && payload.Liked) {
        values.push(localPostLikes)
      } else if ((localIsLiked === false || localIsLiked === 'false') && !payload.Liked) {
        values.push(localPostLikes)
      } else {
        values.push(payload.Liked ? localPostLikes + 1 : localPostLikes - 1)
      }
      return new Promise((resolve, reject) => {
        self.db.transaction(function(transaction) {
          let query = `UPDATE ${tablename} SET ${columns.join(',')} where ${keyColumn} = ${IdValue}`
          transaction.executeSql(query, values, function(transaction, result) {
            resolve(result)
          }, function(transaction, error) {
            reject(error)
          })
        })
      })
    }
  }

  self.updateModulesImageGalleriesPostsLike = async(tableNameArray, keyColumn, payload, IdValue) => {
    if (isNaN(IdValue)) {
      IdValue = `'${IdValue}'`
    }
    if (isNaN(payload)) {
      payload.Album_Id = `'${payload.Album_Id}'`
    }
    let columns = []
    columns.push('IsLiked = ?')
    columns.push('Likes = ?')
    let execQuery1 = `SELECT * FROM ${tableNameArray[1]} WHERE ${keyColumn} = ${IdValue}`
    let responce1 = await self.query(execQuery1)
    let execQuery2 = `SELECT * FROM ${tableNameArray[0]} WHERE ${keyColumn} = ${payload.Album_Id}`
    let responce2 = await self.query(execQuery2)
    if (responce1.rows.length !== 0) {
      let values = []
      let localIsLiked = responce1.rows.item(0).IsLiked
      let localLikes = responce1.rows.item(0).Likes
      values.push(payload.Liked)
      if ((localIsLiked === true || localIsLiked === 'true') && payload.Liked) {
        values.push(localLikes)
      } else if ((localIsLiked === false || localIsLiked === 'false') && !payload.Liked) {
        values.push(localLikes)
      } else {
        values.push(payload.Liked ? localLikes + 1 : localLikes - 1)
      }
      return new Promise((resolve, reject) => {
        self.db.transaction(function(transaction) {
          let query = `UPDATE ${tableNameArray[1]} SET ${columns.join(',')} where ${keyColumn} = ${IdValue}`
          transaction.executeSql(query, values, function(transaction, result) {
            if (responce2.rows.length !== 0) {
              let CountLike
              let localLikes2 = responce2.rows.item(0).Likes
              if ((localIsLiked === true || localIsLiked === 'true') && payload.Liked) {
                CountLike = localLikes2
              } else if ((localIsLiked === false || localIsLiked === 'false') && !payload.Liked) {
                CountLike = localLikes2
              } else {
                CountLike = payload.Liked ? localLikes2 + 1 : localLikes2 - 1
              }
              let execInnerQuery = `UPDATE ${tableNameArray[0]} SET Likes = ${CountLike} where ${keyColumn} = ${payload.Album_Id}`
              self.query(execInnerQuery)
            }
            resolve(result)
          }, function(transaction, error) {
            reject(error)
          })
        })
      })
    }
  }

  self.updateModulesRadioStreamLike = async(tablename, keyColumn, payload, IdValue) => {
    if (isNaN(IdValue)) {
      IdValue = `'${IdValue}'`
    }
    let columns = []
    columns.push('IsLiked = ?')
    let values = []
    values.push(payload.Liked)
    return new Promise((resolve, reject) => {
      self.db.transaction(function(transaction) {
        let query = `UPDATE ${tablename} SET ${columns.join(',')} where ${keyColumn} = ${IdValue}`
        transaction.executeSql(query, values, function(transaction, result) {
          resolve(result)
        }, function(transaction, error) {
          reject(error)
        })
      })
    })
  }

  return self
}

export default DB



// WEBPACK FOOTER //
// ./src/modules/wrapper/dbWrapper.js